import { render, staticRenderFns } from "./ConfirmAdditional.vue?vue&type=template&id=354f14c2&scoped=true"
import script from "./ConfirmAdditional.vue?vue&type=script&lang=js"
export * from "./ConfirmAdditional.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "354f14c2",
  null
  
)

export default component.exports